var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"vuetify-style",staticStyle:{"height":"5rem"}},[_c('v-color-picker',{staticStyle:{"height":"5rem"},attrs:{"dot-size":"50","hide-canvas":"","mode":"hexa"},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }